//--Modules---------------------------------------------------------------------------------------//
import Vue from 'vue'
import App from './App.vue'
import router from './router'

//url handling
import VueRouter from 'vue-router'
Vue.use(VueRouter)

//Cross componant varibles store
import store from './store'
import Vuex from 'vuex'
Vue.use(Vuex)

//html requests
import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'https://ip-rtk-aws.com';
axios.defaults.headers.common['X-Client'] = 'cloudbase';
axios.interceptors.request.use(config => {
    if (config.skipAuth) {
        return config;
    }

    const token = store.getters.token;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      if (router.currentRoute.name !== 'unauthenticated') {
        router.push({name: 'unauthenticated'}).catch(() => {
        });
      }

      return new Promise(() => {
      });
    }

    return Promise.reject(error);
  }
);

//date/time picking
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

//popup alerts (being phased out)
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@sweetalert2/theme-dark/dark.min.css';
Vue.use(VueSweetalert2)

//User input validation
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, { 
	fieldsBagName: 'veeFields',
	events: ''     
});

//Structural framework,
import 'bootstrap'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

//Rich text editor
import "tinymce/tinymce"
import "tinymce/themes/silver" 
import "../public/tinymce/skins/ui/Cloudbase/skin.min.css"
import "../public/tinymce/skins/ui/Cloudbase/content.min.css"

//--Init------------------------------------------------------------------------------------------//
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

